// extracted by mini-css-extract-plugin
export var md = "_4h-4";
export var semantic = "_4h-5";
export var sm = "_4h-3";
export var text = "_4h-6";
export var toggleInput = "_4h-0";
export var toggleSwitch = "_4h-1";
export var xs = "_4h-2";